import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e71cde4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "application-selector" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted mt-2 small" }, "Loading your applications...", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-state-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-briefcase" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "empty-state-title" }, "No applications found", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "empty-state-text" }, "Create your first job application to get started", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle me-2" }, null, -1))
const _hoisted_11 = {
  key: 2,
  class: "application-with-create"
}
const _hoisted_12 = { class: "selector-container" }
const _hoisted_13 = { class: "search-container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search search-icon" }, null, -1))
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "custom-dropdown"
}
const _hoisted_17 = { class: "dropdown-body" }
const _hoisted_18 = {
  key: 0,
  class: "no-results"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, "No matching applications found", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_23 = { class: "app-details" }
const _hoisted_24 = { class: "company-name" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge bg-light text-primary select-badge" }, "Select", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle me-2" }),
  /*#__PURE__*/_createElementVNode("span", null, "Create New Application")
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "divider-line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "divider-text" }, "or"),
  /*#__PURE__*/_createElementVNode("div", { class: "divider-line" })
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle me-2" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Create New Application", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]

import { ref, computed, onMounted, onUnmounted } from "vue";

interface Application {
  _id: string;
  roleTitle: string;
  companyName: string;
  [key: string]: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationSelector',
  props: {
  applications: {
    type: Array as () => Application[],
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["select-application", "create-application"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedApplication = ref<Application | null>(null);
const searchQuery = ref("");
const searchInput = ref<HTMLInputElement | null>(null);
const showDropdown = ref(false);

const filteredApplications = computed(() => {
  if (!searchQuery.value) return props.applications;

  const query = searchQuery.value.toLowerCase();
  return props.applications.filter(
    (app) =>
      app.roleTitle.toLowerCase().includes(query) || app.companyName.toLowerCase().includes(query)
  );
});

function selectApp(app: Application) {
  selectedApplication.value = app;
  searchQuery.value = "";
  showDropdown.value = false;
  emit("select-application", app);
}

function createApplication() {
  searchQuery.value = "";
  showDropdown.value = false;
  emit("create-application");
}

// Close dropdown when clicking outside
function handleClickOutside(event: MouseEvent) {
  const element = event.target as HTMLElement;
  if (searchInput.value && !searchInput.value.contains(element) && 
      !element.closest('.custom-dropdown') && 
      !element.closest('.search-input')) {
    showDropdown.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
  
  // Show selected application in search input if available
  if (props.applications.length > 0 && props.applications[0]) {
    selectedApplication.value = props.applications[0];
  }
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (__props.applications.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("button", {
              onClick: createApplication,
              class: "btn btn-primary"
            }, [
              _hoisted_10,
              _createTextVNode("Add Job Details ")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control search-input",
                  placeholder: selectedApplication.value ? `${selectedApplication.value.roleTitle} at ${selectedApplication.value.companyName}` : 'Search applications...',
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                  onFocus: _cache[1] || (_cache[1] = ($event: any) => (showDropdown.value = true)),
                  ref_key: "searchInput",
                  ref: searchInput
                }, null, 40, _hoisted_15), [
                  [_vModelText, searchQuery.value]
                ])
              ]),
              (showDropdown.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      (filteredApplications.value.length === 0 && !__props.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredApplications.value, (app) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: app._id,
                          class: "application-item",
                          onClick: ($event: any) => (selectApp(app))
                        }, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("h5", null, _toDisplayString(app.roleTitle), 1),
                              _createElementVNode("p", _hoisted_24, _toDisplayString(app.companyName), 1)
                            ]),
                            _hoisted_25
                          ])
                        ], 8, _hoisted_21))
                      }), 128)),
                      _createElementVNode("div", {
                        class: "create-new-item",
                        onClick: createApplication
                      }, _hoisted_27)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_28,
            _createElementVNode("button", {
              class: "btn btn-primary create-app-button",
              onClick: createApplication
            }, _hoisted_31)
          ]))
  ]))
}
}

})